import * as yup from "yup";
import { hasValidRole } from "../helpers";
import RolesAccess from "../../enums/roles";
import TipeSurat from "../../enums/tipeSurat";

export const draftRecomendationLetter = yup
  .object()
  .shape({
    pejabatId: yup
      .string()
      .transform((value) => (typeof value === "object" && value?.value ? value.value : value))
      .required("harus diisi"),
    bulan: yup.string().required("harus diisi"),
    tahun: yup.string().required("harus diisi"),
    nomor_surat: yup.string().when("$roles", {
      is: (roles) => roles && hasValidRole(roles, [RolesAccess.DIREKTUR, RolesAccess.SUPER_ADMIN]), // Sesuaikan dengan log
      then: (schema) => schema.required("Harus diisi"),
      otherwise: (schema) => schema.notRequired(),
    }),
    tanggal_surat: yup.string().when("$roles", {
      is: (roles) => roles && hasValidRole(roles, [RolesAccess.DIREKTUR, RolesAccess.SUPER_ADMIN]), // Sesuaikan dengan log
      then: (schema) => schema.required("Harus diisi"),
      otherwise: (schema) => schema.notRequired(),
    }),
  })
  .required();

export const addManualRecomendationValidation = yup
  .object()
  .shape({
    tipe: yup.string().required("Harus diisi"),
    companyId: yup.string().required("Harus diisi"),
    namaPenanggungJawab: yup.string().required("Harus diisi"),
    jabatanPenanggungJawab: yup.string().required("Harus diisi"),
    nomorRegistrasi: yup.string().required("Harus diisi"),
    alamatDomisili: yup.string().required("Harus diisi"),
    nomorSuratRekomendasi: yup.string().when("tipe", {
      is: (val) => val !== TipeSurat.BARU,
      then: (schema) => schema.required("Harus diisi"),
      otherwise: (schema) => schema.notRequired(),
    }),
    tanggalSuratRekomendasi: yup.string().when("tipe", {
      is: (val) => val !== TipeSurat.BARU,
      then: (schema) => schema.required("Harus diisi"),
      otherwise: (schema) => schema.notRequired(),
    }),
    nomorSuratPerusahaan: yup.string().required("Harus diisi"),
    tanggalSuratPerusahaan: yup.string().required("Harus diisi"),
    file: yup
      .mixed()
      .required("Harus diisi")
      .test("fileType", "Format harus excel", (file) => {
        if (!file) return false;
        return file[0]?.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      }),
  })
  .required();
